/* eslint-disable import/prefer-default-export */
import {
  TravelAnalysisMessages,
  TranslationTravelAnalysisMessages
} from "../interfaces";

export const messages: TranslationTravelAnalysisMessages = {
  [TravelAnalysisMessages.pageTitle]: "Travel Analysis",
  [TravelAnalysisMessages.filterButton]: "Filter",
  [TravelAnalysisMessages.loading]: "Loading...",
  [TravelAnalysisMessages.totalAnalyzed]: "Total Analyzed",
  [TravelAnalysisMessages.successfulTrips]: "Successful Trips",
  [TravelAnalysisMessages.successRate]: "Success Rate",
  [TravelAnalysisMessages.alertsDetected]: "Alerts Detected",
  [TravelAnalysisMessages.target]: "TARGET",
  [TravelAnalysisMessages.alertDistributionTitle]: "Alert Distribution by Type",
  [TravelAnalysisMessages.noAlertsInPeriod]: "No alerts in this period",
  [TravelAnalysisMessages.successRatioTitle]: "Success vs Alerts Ratio",
  [TravelAnalysisMessages.noData]: "No data",
  [TravelAnalysisMessages.success]: "Success",
  [TravelAnalysisMessages.alerts]: "Alerts",
  [TravelAnalysisMessages.efficiency]: "Efficiency",
  [TravelAnalysisMessages.geographicMonitoringTitle]: "Geographic Monitoring",
  [TravelAnalysisMessages.geographicMonitoringSubtitle]: "Alert distribution by operating region",
  [TravelAnalysisMessages.noGeographicData]: "No geographic data",
  [TravelAnalysisMessages.activeVehicles]: "Active Vehicles",
  [TravelAnalysisMessages.activeAlerts]: "Active Alerts",
  [TravelAnalysisMessages.dashboardSubtitle]: "OPERATIONS DASHBOARD",
  [TravelAnalysisMessages.percentOfTotal]: "of total",
  [TravelAnalysisMessages.alertsListTitle]: "Alert Details",
  [TravelAnalysisMessages.columnVehicle]: "Vehicle",
  [TravelAnalysisMessages.columnAlertType]: "Alert Type",
  [TravelAnalysisMessages.columnOrigin]: "Origin",
  [TravelAnalysisMessages.columnDestination]: "Destination",
  [TravelAnalysisMessages.columnDate]: "Date",
  [TravelAnalysisMessages.noAlertsFound]: "No alerts found",
  [TravelAnalysisMessages.loadMore]: "Load more",
  [TravelAnalysisMessages.close]: "Close",
  [TravelAnalysisMessages.tripsUnit]: "trips",
  [TravelAnalysisMessages.columnNumDoc]: "Doc #",
  [TravelAnalysisMessages.columnActions]: "Actions",
  [TravelAnalysisMessages.viewAlertDetails]: "Alert details",
  [TravelAnalysisMessages.viewTravel]: "Open travel",
  [TravelAnalysisMessages.alertDetailsTitle]: "Analysis Details",
  [TravelAnalysisMessages.loadingTravel]: "Loading travel...",
  // Metadata labels — CAN Data Stall
  [TravelAnalysisMessages.metaSource]: "Data source",
  [TravelAnalysisMessages.metaStallType]: "Stall type",
  [TravelAnalysisMessages.metaThreshold]: "Threshold",
  [TravelAnalysisMessages.metaStalledFields]: "Stalled fields",
  [TravelAnalysisMessages.metaTotalCanPackets]: "Total CAN packets",
  // Cross Day Cycle
  [TravelAnalysisMessages.metaStartDate]: "Start date",
  [TravelAnalysisMessages.metaFinishDate]: "Finish date",
  [TravelAnalysisMessages.metaStartDay]: "Start day",
  [TravelAnalysisMessages.metaFinishDay]: "Finish day",
  [TravelAnalysisMessages.metaDurationHours]: "Duration (hours)",
  // False Positive Discharge
  [TravelAnalysisMessages.metaTotalDischargeCommands]: "Total discharge commands",
  [TravelAnalysisMessages.metaCoveredCommands]: "Covered commands",
  [TravelAnalysisMessages.metaOrphanCommands]: "Orphan commands",
  [TravelAnalysisMessages.metaOrphanRatio]: "Orphan ratio (%)",
  [TravelAnalysisMessages.metaCoveredRanges]: "Covered ranges",
  // GPRS Connection Instability
  [TravelAnalysisMessages.metaTotalPackets]: "Total packets",
  [TravelAnalysisMessages.metaMemoryCommands]: "Real offline commands",
  [TravelAnalysisMessages.metaEffectiveRealtimeCommands]: "Effectively realtime commands",
  [TravelAnalysisMessages.metaRealtimeCommands]: "Realtime commands",
  [TravelAnalysisMessages.metaMemoryRatio]: "Real offline ratio (%)",
  [TravelAnalysisMessages.metaThresholdPercent]: "Threshold (%)",
  [TravelAnalysisMessages.metaEffectiveRealtimeThresholdSeconds]: "Effective realtime threshold (s)",
  [TravelAnalysisMessages.metaAvgDelaySeconds]: "Avg transmission delay (s)",
  [TravelAnalysisMessages.metaMaxDelaySeconds]: "Max transmission delay (s)",
  // GPS Positioning Failure
  [TravelAnalysisMessages.metaTotalGpsPackets]: "Total GPS packets",
  [TravelAnalysisMessages.metaInvalidFixCount]: "Invalid positions",
  [TravelAnalysisMessages.metaInvalidRatio]: "Invalid ratio (%)",
  [TravelAnalysisMessages.metaAvgSatellites]: "Average satellites",
  // Hardware Command Deficit
  [TravelAnalysisMessages.metaPacketCount]: "Packets received",
  [TravelAnalysisMessages.metaExpectedPackets]: "Expected packets",
  [TravelAnalysisMessages.metaMinimumRequired]: "Minimum required",
  [TravelAnalysisMessages.metaDeficitPercent]: "Deficit (%)",
  [TravelAnalysisMessages.metaRatePerMinute]: "Rate per minute",
  [TravelAnalysisMessages.metaTravelDurationMinutes]: "Travel duration (min)",
  // Logistics Flow Inconsistency
  [TravelAnalysisMessages.metaRequiredStates]: "Required states",
  [TravelAnalysisMessages.metaActualStates]: "Present states",
  [TravelAnalysisMessages.metaMissingStates]: "Missing states",
  [TravelAnalysisMessages.metaMissingCount]: "Missing count",
  [TravelAnalysisMessages.metaTotalStates]: "Total states",
  [TravelAnalysisMessages.metaNumDoc]: "Doc number",
  // Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.metaIgnitionOnCount]: "Ignition ON commands",
  [TravelAnalysisMessages.metaIdleCount]: "IDLE commands",
  [TravelAnalysisMessages.metaLoadingCount]: "Loading commands",
  [TravelAnalysisMessages.metaUnloadingCount]: "Unloading commands",
  [TravelAnalysisMessages.metaIdleRatio]: "IDLE ratio (%)",
  [TravelAnalysisMessages.successByDayTitle]: "Success by Day",
  [TravelAnalysisMessages.successByPlantTitle]: "Success by Plant",
  [TravelAnalysisMessages.successByRegionalTitle]: "Success by Regional",
  [TravelAnalysisMessages.averageLine]: "Average",
  [TravelAnalysisMessages.noGroupedData]: "No data for the selected period",
  [TravelAnalysisMessages.coordinateViewTitle]: "Coordinate View",
  [TravelAnalysisMessages.coordinateViewVehicle]: "Vehicle",
  [TravelAnalysisMessages.coordinateViewNF]: "NF",
  [TravelAnalysisMessages.coordinateViewGeneral]: "General",
  [TravelAnalysisMessages.coordinateViewContent]: "Content",
  [TravelAnalysisMessages.coordinateViewResult]: "Result",
  [TravelAnalysisMessages.coordinateViewGeneralData]: "General Data",
  [TravelAnalysisMessages.coordinateViewCommandContent]: "Command Content",
  [TravelAnalysisMessages.coordinateViewProcessingResult]: "Processing Result",
  [TravelAnalysisMessages.coordinateViewNoData]: "No data",
  [TravelAnalysisMessages.coordinateViewField]: "Field",
  [TravelAnalysisMessages.coordinateViewValue]: "Value",
  // Alert glossary (help drawer)
  [TravelAnalysisMessages.glossaryButtonLabel]:
    "About the analysis",
  [TravelAnalysisMessages.glossaryDrawerTitle]:
    "Understanding the Travel Analysis",
  [TravelAnalysisMessages.glossaryIntroTitle]: "How the analysis works",
  [TravelAnalysisMessages.glossaryIntroText]:
    "A ticket travel has a complete cycle when it records the 5 statuses (On the way, At the jobsite, Unloading, Returning and At the plant) and, when the client uses an integration, sends all of them. Each failed travel gets a single cause: the one that explains the first missing status. The classification runs by itself when the travel ends or is canceled. The telemetry alerts, further below, warn about data quality and do not count in the complete cycle.",
  [TravelAnalysisMessages.glossaryWhenLabel]: "When it fires",
  [TravelAnalysisMessages.glossaryAppliesLabel]: "Applies to",
  [TravelAnalysisMessages.glossaryMetadataLabel]: "Captured details (metadata)",
  [TravelAnalysisMessages.glossaryAppliesAll]: "All vehicles",
  [TravelAnalysisMessages.glossaryAppliesMixerPump]: "Concrete mixers and pump trucks",
  [TravelAnalysisMessages.glossaryAppliesMixer]: "Concrete mixers",
  [TravelAnalysisMessages.glossaryAppliesMixerDoc]: "Concrete mixers with a Doc number (concrete travel)",
  // Glossary — GPRS Connection Instability
  [TravelAnalysisMessages.glossaryGprsTitle]: "GPRS connection instability",
  [TravelAnalysisMessages.glossaryGprsDesc]:
    "Indicates the tracker lost its data signal (GPRS) during the travel. Packets captured while offline are stored in the device memory and only reach the server once the signal returns, arriving late. A high volume of these late packets suggests poor coverage or a carrier/SIM issue, and may leave gaps in the route.",
  [TravelAnalysisMessages.glossaryGprsWhen]:
    "When 30% or more of the packets arrived late from memory (transmission delay of 60s or more). Memory packets arriving in under 60s are treated as real-time and do not count.",
  [TravelAnalysisMessages.glossaryGprsMeta]:
    "The numbers show how many packets came in real time, how many actually arrived late from memory, and the average and maximum transmission delay — the larger the delay, the worse the signal was.",
  // Glossary — GPS Positioning Failure
  [TravelAnalysisMessages.glossaryGpsTitle]: "GPS positioning failure",
  [TravelAnalysisMessages.glossaryGpsDesc]:
    "Indicates the device could not obtain a reliable satellite position for a large part of the travel. It can be caused by obstruction (tunnels, enclosed areas), an antenna problem or few visible satellites, affecting the accuracy of the recorded route.",
  [TravelAnalysisMessages.glossaryGpsWhen]:
    "When 30% or more of the packets with GPS data had no valid satellite fix (invalid FIX).",
  [TravelAnalysisMessages.glossaryGpsMeta]:
    "Show the total GPS packets, how many had no fix and the average number of satellites captured — low averages reinforce reception difficulty.",
  // Glossary — Cross Day Cycle
  [TravelAnalysisMessages.glossaryCrossDayTitle]: "Cross-day cycle (D+1)",
  [TravelAnalysisMessages.glossaryCrossDayDesc]:
    "Flags travels that started on one day and only finished on the next. Crossing into a new day impacts the daily productivity closing, since the travel appears on two different days.",
  [TravelAnalysisMessages.glossaryCrossDayWhen]:
    "When the start day differs from the finish day and the travel lasted 6 hours or more (short travels that merely cross midnight are ignored).",
  [TravelAnalysisMessages.glossaryCrossDayMeta]:
    "Show the start and finish dates and days, plus the total travel duration in hours.",
  // Glossary — Hardware Command Deficit
  [TravelAnalysisMessages.glossaryHwDeficitTitle]: "Hardware command deficit",
  [TravelAnalysisMessages.glossaryHwDeficitDesc]:
    "Indicates the tracker transmitted fewer packets than expected for the travel duration. It may signal a faulty device, one turned off part of the time, or a transmission problem, reducing the reliability of the travel data.",
  [TravelAnalysisMessages.glossaryHwDeficitWhen]:
    "When the number of received packets fell below 50% of the expected (baseline of 1 packet every 2 minutes). Evaluated only on travels longer than 5 minutes.",
  [TravelAnalysisMessages.glossaryHwDeficitMeta]:
    "Compare received packets with expected ones and show the percentage deficit and the packets-per-minute rate.",
  // Glossary — Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.glossarySensorIdleTitle]: "Active sensor command deficit (high IDLE)",
  [TravelAnalysisMessages.glossarySensorIdleDesc]:
    "Indicates that, with the vehicle running, the drum stayed idle — neither loading nor unloading — for a large part of the travel. It may point to a faulty drum sensor or a communication problem, hurting the reading of the loading and unloading stages.",
  [TravelAnalysisMessages.glossarySensorIdleWhen]:
    "When, among the packets with ignition on, 50% or more had the drum idle (IDLE). Evaluated with at least 10 ignition-on packets.",
  [TravelAnalysisMessages.glossarySensorIdleMeta]:
    "Show how many packets had ignition on and, of those, how many were loading, unloading or idle (IDLE).",
  // Glossary — Logistics Flow Inconsistency
  [TravelAnalysisMessages.glossaryLogisticsTitle]: "Logistics flow inconsistency",
  [TravelAnalysisMessages.glossaryLogisticsDesc]:
    "Flags concrete travels that did not go through all the expected cycle states (At the plant → On the way → At construction site → Unloading → Returning). A missing state may indicate a detection failure, an atypical route or a travel logging issue.",
  [TravelAnalysisMessages.glossaryLogisticsWhen]:
    "When at least one of the required states is missing. It checks the presence of each state, not the order.",
  [TravelAnalysisMessages.glossaryLogisticsMeta]:
    "List the required states, the ones that occurred and the ones missing from the travel.",
  // Glossary — CAN Data Stall
  [TravelAnalysisMessages.glossaryCanStallTitle]: "Stalled CAN data (full or partial)",
  [TravelAnalysisMessages.glossaryCanStallDesc]:
    "Indicates that data coming from the vehicle's CAN bus (speed, RPM, fuel, odometer) became 'frozen', repeating the same value across several consecutive packets. It usually points to a CAN reading failure, hurting the vehicle telemetry.",
  [TravelAnalysisMessages.glossaryCanStallWhen]:
    "When a CAN field repeats the same value across 10 consecutive packets or more. 'Total' = all fields frozen; 'Partial' = at least one field frozen.",
  [TravelAnalysisMessages.glossaryCanStallMeta]:
    "Show which fields stalled, for how many consecutive packets and the value that stayed repeated.",
  // Glossary — False Positive Discharge
  [TravelAnalysisMessages.glossaryFalseDischargeTitle]: "False discharge positives",
  [TravelAnalysisMessages.glossaryFalseDischargeDesc]:
    "Flags drum discharge commands that occurred outside any valid unloading context (not while unloading, at the plant, in a trusted location or during an improper-discharge event). These 'orphan' commands may be sensor noise or discharges not detected correctly.",
  [TravelAnalysisMessages.glossaryFalseDischargeWhen]:
    "When there are 3 or more orphan discharge commands (not covered by any known discharge period).",
  [TravelAnalysisMessages.glossaryFalseDischargeMeta]:
    "Show the total discharge commands, how many were covered by a valid context and how many were left orphan.",
  // Travel cycle analysis
  [TravelAnalysisMessages.cycleKpiTicketTravels]: "ticket travels",
  [TravelAnalysisMessages.cycleKpiComplete]: "Complete cycle",
  [TravelAnalysisMessages.cycleKpiCompleteSub]: "travels with the 5 statuses",
  [TravelAnalysisMessages.cycleKpiFailed]: "Failed travels",
  [TravelAnalysisMessages.cycleKpiSeeCauses]: "see causes",
  [TravelAnalysisMessages.cycleKpiHardware]: "Hardware to check",
  [TravelAnalysisMessages.cycleKpiSensors]: "discharge sensors",
  [TravelAnalysisMessages.cycleKpiTrackers]: "trackers",
  [TravelAnalysisMessages.cycleKpiVehicles]: "vehicles",
  [TravelAnalysisMessages.cycleImpactTitle]: "Where the failures are",
  [TravelAnalysisMessages.cycleImpactHint]: "Each failed travel gets a single cause. Click a cause to see the vehicles and, for each vehicle, its travels.",
  [TravelAnalysisMessages.cycleNoFailures]: "No failures in the period.",
  [TravelAnalysisMessages.groupEquipment]: "Truck equipment",
  [TravelAnalysisMessages.groupEquipmentDesc]: "The discharge sensor or the tracker did not record what happened on the travel.",
  [TravelAnalysisMessages.groupRegistration]: "Plant and jobsite registration",
  [TravelAnalysisMessages.groupRegistrationDesc]: "The registered plant or jobsite location does not match where the truck operates.",
  [TravelAnalysisMessages.groupRoutine]: "Plant and dispatch routine",
  [TravelAnalysisMessages.groupRoutineDesc]: "A maneuver right after leaving the plant, or a ticket swapped or replaced.",
  [TravelAnalysisMessages.groupOthers]: "Others",
  [TravelAnalysisMessages.groupOthersDesc]: "Registered statuses that did not reach the integration and cases with no pattern.",
  [TravelAnalysisMessages.outcomeComplete]: "Complete cycle",
  [TravelAnalysisMessages.outcomeSensorStopped]: "Discharge sensor stopped",
  [TravelAnalysisMessages.outcomeSensorStoppedDesc]: "The truck reached the jobsite, but the sensor misses the discharge on almost every travel.",
  [TravelAnalysisMessages.outcomeSensorStoppedAction]: "Sensor maintenance",
  [TravelAnalysisMessages.outcomeSensorIntermittent]: "Intermittent discharge sensor",
  [TravelAnalysisMessages.outcomeSensorIntermittentDesc]: "The sensor records the discharge on some travels and misses it on others.",
  [TravelAnalysisMessages.outcomeSensorIntermittentAction]: "Check the sensor and its cable",
  [TravelAnalysisMessages.outcomeDischargeOneOff]: "Discharge not recorded (one-off)",
  [TravelAnalysisMessages.outcomeDischargeOneOffDesc]: "A truck with a healthy sensor that missed the discharge on an isolated travel.",
  [TravelAnalysisMessages.outcomeDischargeOneOffAction]: "Keep an eye on it",
  [TravelAnalysisMessages.outcomeTrackerWithoutSignal]: "Tracker without signal",
  [TravelAnalysisMessages.outcomeTrackerWithoutSignalDesc]: "The tracker sent nothing during the travel.",
  [TravelAnalysisMessages.outcomeTrackerWithoutSignalAction]: "Tracker maintenance",
  [TravelAnalysisMessages.outcomeInactivePlant]: "Plant inactive in the registry",
  [TravelAnalysisMessages.outcomeInactivePlantDesc]: "The origin plant is inactive: the truck is not recognized there and the travel never starts.",
  [TravelAnalysisMessages.outcomeInactivePlantAction]: "Reactivate the plant in Registration › Locations",
  [TravelAnalysisMessages.outcomeJobsiteNotDetected]: "Jobsite arrival not detected",
  [TravelAnalysisMessages.outcomeJobsiteNotDetectedDesc]: "The truck left the plant but was not recognized inside the jobsite.",
  [TravelAnalysisMessages.outcomeJobsiteNotDetectedAction]: "Adjust the jobsite location",
  [TravelAnalysisMessages.outcomeDischargeOutsideJobsite]: "Discharge outside the jobsite area",
  [TravelAnalysisMessages.outcomeDischargeOutsideJobsiteDesc]: "The sensor recorded the discharge outside the registered jobsite area.",
  [TravelAnalysisMessages.outcomeDischargeOutsideJobsiteAction]: "Adjust the jobsite location from the alert",
  [TravelAnalysisMessages.outcomeJobsiteNextToPlant]: "Jobsite next to the plant",
  [TravelAnalysisMessages.outcomeJobsiteNextToPlantDesc]: "The jobsite is less than 500 m from the plant: the truck never leaves the plant area and the travel never starts.",
  [TravelAnalysisMessages.outcomeJobsiteNextToPlantAction]: "Check the plant and jobsite areas",
  [TravelAnalysisMessages.outcomeShortPlantExit]: "Short plant exit",
  [TravelAnalysisMessages.outcomeShortPlantExitDesc]: "Left and came back to the plant within 10 minutes, for a maneuver or weighing, which closed the travel before the delivery.",
  [TravelAnalysisMessages.outcomeShortPlantExitAction]: "Maneuvers and weighing inside the plant area",
  [TravelAnalysisMessages.outcomeReplacedTicket]: "Ticket replaced by another",
  [TravelAnalysisMessages.outcomeReplacedTicketDesc]: "The truck ran another ticket and this one never started: it was canceled by the next one or stayed in the queue.",
  [TravelAnalysisMessages.outcomeReplacedTicketAction]: "Check the order of the tickets",
  [TravelAnalysisMessages.outcomeTwoTickets]: "Two tickets on the same truck",
  [TravelAnalysisMessages.outcomeTwoTicketsDesc]: "Two tickets for the same truck less than 15 minutes apart: only the last one goes on.",
  [TravelAnalysisMessages.outcomeTwoTicketsAction]: "One ticket per load",
  [TravelAnalysisMessages.outcomeIntegrationNotSent]: "Status not sent to the integration",
  [TravelAnalysisMessages.outcomeIntegrationNotSentDesc]: "The 5 statuses were recorded, but at least one was not sent to the integration.",
  [TravelAnalysisMessages.outcomeIntegrationNotSentAction]: "Check the integration log",
  [TravelAnalysisMessages.outcomeOther]: "No pattern identified",
  [TravelAnalysisMessages.outcomeOtherDesc]: "The status sequence fits none of the causes above.",
  [TravelAnalysisMessages.outcomeOtherAction]: "Review the travel",
  [TravelAnalysisMessages.cyclePlacesByRegional]: "Complete cycle by Regional",
  [TravelAnalysisMessages.cyclePlacesByPlant]: "Complete cycle by Plant",
  [TravelAnalysisMessages.cyclePlacesHint]: "Click a name to filter the screen by it.",
  [TravelAnalysisMessages.toggleRegional]: "Regional",
  [TravelAnalysisMessages.togglePlant]: "Plant",
  [TravelAnalysisMessages.toggleTable]: "Table",
  [TravelAnalysisMessages.toggleChart]: "Chart",
  [TravelAnalysisMessages.columnRegional]: "Regional",
  [TravelAnalysisMessages.columnPlant]: "Plant",
  [TravelAnalysisMessages.columnTravels]: "Travels",
  [TravelAnalysisMessages.columnCycleComplete]: "Complete cycle",
  [TravelAnalysisMessages.columnFailuresByType]: "Failures by type",
  [TravelAnalysisMessages.columnTopCause]: "Main cause",
  [TravelAnalysisMessages.fewTravels]: "few travels",
  [TravelAnalysisMessages.ofTravels]: "of the travels",
  [TravelAnalysisMessages.noRegional]: "No regional",
  [TravelAnalysisMessages.hardwareTitle]: "Hardware to check",
  [TravelAnalysisMessages.hardwareHint]: "Vehicles whose discharge sensor or tracker made travels fail in the period. The row button shows the travels.",
  [TravelAnalysisMessages.hwAll]: "All",
  [TravelAnalysisMessages.hwSensorStopped]: "Sensor stopped",
  [TravelAnalysisMessages.hwSensorIntermittent]: "Intermittent sensor",
  [TravelAnalysisMessages.hwTracker]: "Tracker without signal",
  [TravelAnalysisMessages.columnProblem]: "Problem",
  [TravelAnalysisMessages.columnDischarges]: "Discharges recorded",
  [TravelAnalysisMessages.columnFailedTravels]: "Failed travels",
  [TravelAnalysisMessages.columnLastUnload]: "Last discharge",
  [TravelAnalysisMessages.columnLastSignal]: "Last signal",
  [TravelAnalysisMessages.wordOf]: "of",
  [TravelAnalysisMessages.hwSensorShort]: "sensor",
  [TravelAnalysisMessages.hwTrackerShort]: "tracker",
  [TravelAnalysisMessages.noHardware]: "No hardware to check in the filter",
  [TravelAnalysisMessages.cycleDrilldownTitle]: "Failure Details",
  [TravelAnalysisMessages.columnMainPlant]: "Main plant",
  [TravelAnalysisMessages.columnTravelsWithCause]: "Travels with this cause",
  [TravelAnalysisMessages.columnShareOfVehicle]: "% of the vehicle's travels",
  [TravelAnalysisMessages.columnRegisteredStates]: "Recorded statuses",
  [TravelAnalysisMessages.columnCause]: "Cause",
  [TravelAnalysisMessages.stateRegistered]: "recorded",
  [TravelAnalysisMessages.stateNotRegistered]: "not recorded",
  [TravelAnalysisMessages.telemetryTitle]: "Telemetry alerts",
  [TravelAnalysisMessages.telemetryHint]: "Warnings about the quality of the tracker and sensor data. They do not count in the complete cycle.",
  [TravelAnalysisMessages.glossaryCyclesSection]: "Cycle failure causes",
  [TravelAnalysisMessages.glossaryAlertsSection]: "Telemetry alerts",
  [TravelAnalysisMessages.glossaryWhatToDo]: "What to do",
  [TravelAnalysisMessages.glossarySensorHealth]: "Stopped sensor: recorded the discharge on less than 10% of the travels that reached the jobsite in the period. Intermittent: between 10% and 80%. With fewer than 5 travels at the jobsite, it counts as stopped when it has recorded no discharge for more than 14 days.",
  [TravelAnalysisMessages.dailyTitle]: "Complete cycle per day",
  [TravelAnalysisMessages.dailyHint]: "Only days with travels. The dotted green line is the period average and the dashed gray one shows the trend of the last 5 days.",
  [TravelAnalysisMessages.movingAverage]: "5-day moving average",
  [TravelAnalysisMessages.periodAverage]: "Period average",
  [TravelAnalysisMessages.averageShort]: "average",
  [TravelAnalysisMessages.generalLine]: "Overall",
  [TravelAnalysisMessages.selectedPlaces]: "{{count}} selected",
  [TravelAnalysisMessages.chartNotePlaces]: "Pick one or more in the selector. The Overall line adds them all and the dotted green one is the period average. Days with fewer than 5 travels are left out of a line.",
  [TravelAnalysisMessages.backTo]: "Back to {{name}}",
  [TravelAnalysisMessages.tileTravels]: "Travels",
  [TravelAnalysisMessages.tileShareOfFilter]: "Of the filter's travels",
  [TravelAnalysisMessages.tileVehicles]: "Vehicles",
  [TravelAnalysisMessages.tileGroup]: "Group",
  [TravelAnalysisMessages.whatItIs]: "What it is",
  [TravelAnalysisMessages.byRegional]: "By regional",
  [TravelAnalysisMessages.byPlant]: "By plant",
  [TravelAnalysisMessages.vehiclesWithCause]: "Vehicles with this cause ({{count}})",
  [TravelAnalysisMessages.tileTravelsInPeriod]: "Travels in the period",
  [TravelAnalysisMessages.tileWithFailure]: "Failed",
  [TravelAnalysisMessages.tileWithThisCause]: "With this cause",
  [TravelAnalysisMessages.tilePlant]: "Plant",
  [TravelAnalysisMessages.tileSensor]: "Discharge sensor",
  [TravelAnalysisMessages.sensorStopped]: "Stopped",
  [TravelAnalysisMessages.sensorIntermittent]: "Intermittent",
  [TravelAnalysisMessages.sensorOk]: "Working",
  [TravelAnalysisMessages.sensorDetail]: "discharge on {{pct}} of {{reached}} travels at the jobsite · last {{date}}",
  [TravelAnalysisMessages.failuresByCause]: "Failures by cause",
  [TravelAnalysisMessages.failedTravelsCount]: "Failed travels ({{count}})",
  [TravelAnalysisMessages.columnDetails]: "Details",
  [TravelAnalysisMessages.stateOnTheWay]: "On the way",
  [TravelAnalysisMessages.stateJobsite]: "At the jobsite",
  [TravelAnalysisMessages.stateDischarging]: "Unloading",
  [TravelAnalysisMessages.stateReturning]: "Returning",
  [TravelAnalysisMessages.statePlant]: "At the plant",
  [TravelAnalysisMessages.glossaryCausesCount]: "{{count}} causes",
  [TravelAnalysisMessages.glossaryAlertsCount]: "{{count}} alerts"
};
